export const download = {
  accessButton: "Access",
  downloadButton: "Download",
  webDesc: "Access the site in your browser",
  windowsDesc: "Download the installer for Windows",
  linuxDesc: "Download the installer for Linux",
  androidDesc: "Download the APK for Android",
  iosDesc: "Download the iOS app",
  title: "Download the app",
  subtitle:
    "Access Araria anywhere, in your browser, computer or on your smartphone",
};
